/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const SERVICE_FIELD_KEYS = {
  list: 'service.list',
} as const;

export const SERVICE_FIELD_KEY_LIST = [SERVICE_FIELD_KEYS.list] as const;

export const SERVICE_ACTION_KEYS = {
  add: 'service.add',
  remove: 'service.remove',
  edit: 'service.edit',
} as const;

export const SERVICE_ACTION_KEY_LIST = Object.values(SERVICE_ACTION_KEYS);
